import React from 'react'

const ROWS = [
  { kind: 'menager', tag: '\u{1F33F}', name: 'Courgette, pulpe et peau, crue', qty: '120,0 g' },
  { kind: 'menager', tag: '\u{1F33F}', name: 'B\u0153uf, steak haché 5 % MG', qty: '95,0 g' },
  { kind: 'industriel', tag: '\u{1F3ED}', name: 'ADVANCE — Sterilized Chicken', qty: '59,0 g' },
  { kind: 'complement', tag: '\u{1F9C2}', name: 'Huile de colza', qty: '5,0 g' },
  { kind: 'complement', tag: '\u{1F9C2}', name: "Vit'i5 Bleu", qty: '4,0 g' },
]

const METERS = [
  { label: 'Protéines (%MS)', value: 32.4, min: 18, max: 55 },
  { label: 'Lipides (%MS)', value: 18.3, min: 10, max: 30 },
  { label: 'Calcium (%MS)', value: 0.9, min: 0.5, max: 1.3 },
  { label: 'Ratio Ca/P', value: 1.4, min: 1.0, max: 2.0 },
]

const Meter = ({ label, value, min, max }) => {
  const pct = ((value - min) / (max - min)) * 100
  return (
    <div style={{ marginBottom: 6 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
        <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 700, color: 'var(--text-strong)' }}>{label}</span>
        <span><strong>{value}</strong> <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>cible {min}–{max}</span></span>
      </div>
      <div style={{ height: 6, background: 'var(--ink-200)', borderRadius: 99, overflow: 'hidden', position: 'relative' }}>
        <div style={{ position: 'absolute', height: '100%', width: `${Math.min(pct, 100)}%`, background: 'var(--status-ok-solid)', borderRadius: 99 }} />
      </div>
    </div>
  )
}

const RecipeBuilderMock = () => (
  <div className="rb-mock">
    {/* Browser chrome */}
    <div className="rb-mock__bar">
      <div className="rb-mock__dots">
        <span style={{ background: '#FF5F57' }} />
        <span style={{ background: '#FFBD2E' }} />
        <span style={{ background: '#28C840' }} />
      </div>
      <div className="rb-mock__url">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
        app.fetchy.vet/diet
      </div>
    </div>

    {/* Patient header */}
    <div className="rb-mock__body">
      <div className="rb-mock__head">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div className="rb-mock__avatar">O</div>
          <div>
            <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, fontSize: 15, color: 'var(--text-strong)', lineHeight: 1.1 }}>Olaf</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Chien castré · 10,0 kg · BCS 5/9</div>
          </div>
        </div>
        <div className="rb-mock__autopilot">
          <span>AutoPilot</span>
          <span className="rb-mock__toggle" />
        </div>
      </div>

      {/* Ingredient rows */}
      <div className="rb-mock__rows">
        {ROWS.map((r, i) => (
          <div key={i} className={`rb-mock__row rb-mock__row--${r.kind}`}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
              <span style={{ fontSize: 13 }}>{r.tag}</span>
              <span className="rb-mock__iname">{r.name}</span>
            </div>
            <span className="rb-mock__qty">{r.qty}</span>
          </div>
        ))}
      </div>

      {/* Nutrient meters */}
      <div className="rb-mock__meters">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, fontSize: 13, color: 'var(--text-strong)' }}>Adéquation nutritionnelle</span>
          <span className="rb-mock__badge-ok">Dans la cible</span>
        </div>
        {METERS.map((m) => <Meter key={m.label} {...m} />)}
      </div>
    </div>
  </div>
)

export default RecipeBuilderMock
